import axios from 'axios';
import pako from 'pako';
export async function getCards(cnpj) {
    try {
        const url = process.env.VUE_APP_APIURL;
        const cardsResponse = await axios.get(`${url}/pagamentos/sitef/getCards`, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': cnpj
            },
        });
        const bufferObject = cardsResponse.data.cards; 
        const compressedDataArray = bufferObject.data;
        const decompressedDataString = pako.inflate(new Uint8Array(compressedDataArray), { 
            to: 'string' 
        });
        const cards = JSON.parse(decompressedDataString);
        return cards
    } catch (error) {
        console.error('Erro ao obter cartões do usuario:', error);
        throw new Error('Erro ao obter cartões do usuario:', error);
    }
}